import React from "react";
import { GET } from "Common/api";
import LuvitComponent from "LuvitComponent";

export default class UnitInformation extends LuvitComponent {
  constructor(props, context) {
    super(props, context, "ActivityCentre");
  }

  async componentWillMount() {
    let items = await GET("v1/portalsiteoverview/unitinformation/items");
    this.setState({ ready: true, items });
  }

  doRender() {
    if (!this.state.ready) return <div />;

    let items = this.state.items.map((i) => (
      <div key={i.unitInformationID} className="panel-news-item fr-view">
        <h3 className="panel-news-title">{i.header}</h3>
        <div dangerouslySetInnerHTML={{ __html: i.text }}></div>
      </div>
    ));

    return (
      <div>
        <div className="panel-header">
          <div className="icon-info" aria-hidden="true" />
          <h3 className="panel-heading">
            <span className="paneltitle">{this.l("unitinformation")}</span>
          </h3>
        </div>
        <div>
          {items.length == 0 && <div>{this.l("noinformation")}</div>}
          {items}
        </div>
      </div>
    );
  }
}
